import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import func from "../../../services/functions";

const exportPdf = (data, columns, reportTitle, dateRange, companyName) => {
  if (!data || data.length === 0) return;

  // Use landscape for tables with many columns
  const orientation = columns.length > 6 ? "landscape" : "portrait";
  const doc = new jsPDF({ orientation });

  // Header
  doc.setFontSize(14);
  doc.setTextColor(0, 117, 103);
  doc.text(companyName || "Company Report", 14, 18);

  doc.setFontSize(11);
  doc.setTextColor(51, 51, 51);
  doc.text(reportTitle, 14, 26);

  if (dateRange?.fromDate && dateRange?.toDate) {
    doc.setFontSize(9);
    doc.setTextColor(102, 102, 102);
    doc.text(
      `Period: ${moment(dateRange.fromDate).format("DD/MM/YYYY")} - ${moment(dateRange.toDate).format("DD/MM/YYYY")}`,
      14,
      33
    );
  }

  // Build table columns and data
  const tableColumns = columns.map((col) => ({
    header: col.header,
    dataKey: col.field,
  }));

  const tableData = data.map((row) => {
    const obj = {};
    columns.forEach((col) => {
      const value = row[col.field];
      obj[col.field] = col.isMoney
        ? `${func.getFormattedMoneyValue(value)} L`
        : value ?? "";
    });
    return obj;
  });

  // Calculate column styles for better sizing
  const columnStyles = {};
  columns.forEach((col) => {
    if (col.isMoney) {
      columnStyles[col.field] = { halign: "right", cellWidth: "auto" };
    }
  });

  // Adjust font size based on number of columns
  const fontSize = columns.length > 12 ? 6 : columns.length > 8 ? 7 : 8;

  autoTable(doc, {
    columns: tableColumns,
    body: tableData,
    startY: dateRange?.fromDate ? 38 : 32,
    styles: {
      fontSize,
      cellPadding: 2,
      overflow: "linebreak",
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [0, 117, 103],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: fontSize,
      cellPadding: 3,
      halign: "center",
    },
    alternateRowStyles: {
      fillColor: [245, 247, 250],
    },
    columnStyles,
    tableWidth: "auto",
    margin: { left: 10, right: 10 },
  });

  const fileName = `${reportTitle.replace(/\s+/g, "_")}_${moment().format("YYYY-MM-DD")}.pdf`;
  doc.save(fileName);
};

export default exportPdf;
